export default "__VITE_ASSET__CETeVvIy__"